import { Link } from "react-router-dom";
import logoRoiDuStreaming from "@/assets/logo-roi-du-streaming-iptv.webp";

const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-background border-t border-border py-8 md:py-12 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Logo */}
        <div className="flex justify-center mb-6 md:mb-8">
          <Link to="/">
            <img 
              src={logoRoiDuStreaming} 
              alt="Roi du Streaming" 
              className="h-16 md:h-20 w-auto"
            />
          </Link>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center items-center gap-2 md:gap-4 lg:gap-6 mb-6 md:mb-8">
          <Link
            to="/"
            className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors font-medium px-2 py-1"
          >
            Accueil
          </Link>
          <Link
            to="/nos-offres"
            className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors font-medium px-2 py-1"
          >
            Nos offres
          </Link>
          <Link
            to="/tutoriels"
            className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors font-medium px-2 py-1"
          >
            Tutoriels
          </Link>
          <Link
            to="/avis-clients"
            className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors font-medium px-2 py-1"
          >
            Avis clients
          </Link>
          <Link
            to="/#contact"
            onClick={() => scrollToSection("contact")}
            className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors font-medium px-2 py-1"
          >
            Contact
          </Link>
          <Link
            to="/nos-offres"
            className="text-sm md:text-base text-muted-foreground hover:text-primary transition-colors font-medium px-2 py-1"
          >
            Je m'abonne
          </Link>
          <Link
            to="/affiliate"
            className="bg-primary hover:bg-primary/90 text-primary-foreground px-3 md:px-4 py-1.5 md:py-2 rounded-lg font-semibold transition-colors text-sm md:text-base"
            aria-label="Devenir affilié RoiDuStreaming et gagner des commissions"
          >
            🤝 Devenir Affilié
          </Link>
        </nav>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 text-center mb-6 md:mb-8 py-4 md:py-6 border-y border-border">
          <div>
            <div className="text-lg md:text-xl font-bold gradient-text">100K+</div>
            <div className="text-xs md:text-sm text-muted-foreground">Films</div>
          </div>
          <div>
            <div className="text-lg md:text-xl font-bold gradient-text">25K+</div>
            <div className="text-xs md:text-sm text-muted-foreground">Séries</div>
          </div>
          <div>
            <div className="text-lg md:text-xl font-bold gradient-text">16K+</div>
            <div className="text-xs md:text-sm text-muted-foreground">Chaînes</div>
          </div>
          <div>
            <div className="text-lg md:text-xl font-bold gradient-text">4K</div>
            <div className="text-xs md:text-sm text-muted-foreground">Qualité</div>
          </div>
        </div>

        {/* SEO Internal Links */}
        <div className="mb-6 md:mb-8">
          <h3 className="text-sm font-semibold text-foreground mb-3 text-center">Découvrez nos services IPTV</h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            <Link
              to="/iptv-france"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              IPTV France
            </Link>
            <Link
              to="/abonnement-iptv"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              Abonnement IPTV
            </Link>
            <Link
              to="/iptv-pas-cher"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              IPTV Pas Cher
            </Link>
            <Link
              to="/abonnement-iptv-3-mois"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              IPTV 3 Mois
            </Link>
            <Link
              to="/abonnement-iptv-6-mois"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              IPTV 6 Mois
            </Link>
            <Link
              to="/abonnement-iptv-12-mois"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              IPTV 12 Mois
            </Link>
            <Link
              to="/faq"
              className="text-xs md:text-sm text-muted-foreground hover:text-primary transition-colors px-3 py-1.5 bg-muted/30 rounded-full hover:bg-muted/50"
            >
              FAQ
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center text-xs md:text-sm">
          <p className="text-muted-foreground">© 2026 RoiDuStreaming. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;